import styled from 'styled-components'

export const Container = styled.div`
  margin-bottom: 16px;
`
